import Loader from '@axa-japan/design-system-react/Loader';
import Text from '@axa-japan/design-system-react/Text';

type CustomLoaderProps = {
  type?: 'loading' | 'redirecting';
  text?: string;
};

const SpinnerText = {
  loading: '読み込み中です。しばらくお待ちください。',
  redirecting: '認証中',
};

const CustomLoader = ({ type = 'loading', text }: CustomLoaderProps) => {
  return (
    <div className="fixed top-0 left-0 bg-white bg-opacity-80 z-50 flex items-center justify-center h-screen w-screen bg-gray-100">
      <div className="bg-slate-50 rounded-lg p-12 w-90 text-center">
        <div className="flex justify-center mb-4">
          <Loader size="md" />
        </div>
        <Text align="center">{text ? text : SpinnerText[type]}</Text>
      </div>
    </div>
  );
};

export default CustomLoader;
